try {
    // 2. Function to open the modal
    window.openModal = function () {
        // Make openModal global
        const modal = document.getElementById("language-modal");
        modal.classList.add("active");
        document.body.classList.add("overflow-hidden");
    };

    // 3. Function to close the modal
    window.closeModal = function () {
        const modal = document.getElementById("language-modal");
        modal.classList.remove("active");
        document.body.classList.remove("overflow-hidden");
    };

    // 4. Function for modal redirect
    window.redirectModal = function () {
        const selectedLanguage = document.querySelector(
            'input[name="language"]:checked'
        ).value;
        if (selectedLanguage === "pl") {
            window.location.href = "https://dirrtytownclothing.pl/";
        } else if (selectedLanguage === "en") {
            window.location.href = "https://dirrtytownclothing.com/";
        }
    };
} catch (error) {
    console.error("Error setting up modal:", error);
}